/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnMetricDistrict } from './en-metric-district';
import { EnMetricMovement } from './en-metric-movement';
import { EnMetricSide } from './en-metric-side';
 /**
 *
 *
 * @export
 * @interface UpdateRomTargetDto
 */
export interface UpdateRomTargetDto {

    /**
     * @type {EnMetricDistrict}
     * @memberof UpdateRomTargetDto
     */
    district?: EnMetricDistrict;

    /**
     * @type {EnMetricSide}
     * @memberof UpdateRomTargetDto
     */
    side?: EnMetricSide;

    /**
     * @type {EnMetricMovement}
     * @memberof UpdateRomTargetDto
     */
    movement?: EnMetricMovement;

    /**
     * Target ROM value in degrees [-180, 180]
     *
     * @type {number}
     * @memberof UpdateRomTargetDto
     */
    goalDegrees?: number;
}
